import type { ReactNode } from "react";

import { cn } from "@/shared/lib/utils/cn";
import { ScrollArea } from "@/shared/ui/shadcn-components/scroll-area";

interface ChatLayoutProps {
  children: ReactNode;
  /** Centers content (empty/home state). Use false for a top-aligned thread view. */
  centered?: boolean;
  /** Apply the default page wash. Disable when a custom background sits behind. */
  surface?: boolean;
  className?: string;
  contentClassName?: string;
}

/**
 * Shared shell for chat screens (home empty state, active threads, etc.).
 * Sits inside the app sidebar layout.
 */
export function ChatLayout({
  children,
  centered = true,
  surface = true,
  className,
  contentClassName,
}: ChatLayoutProps) {
  const content = (
    <div
      className={cn("w-full max-w-3xl", centered ? "space-y-8" : "flex flex-col", contentClassName)}
    >
      {children}
    </div>
  );

  return (
    <div className={cn("flex min-h-0 flex-1 flex-col", surface && "page-surface", className)}>
      {centered ? (
        <div className="flex flex-1 items-center justify-center p-8">{content}</div>
      ) : (
        <ScrollArea className="min-h-0 flex-1">
          <div className="flex min-h-full items-stretch justify-center p-8">{content}</div>
        </ScrollArea>
      )}
    </div>
  );
}
